"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("../../colors"));

var _ = require("../..");

var _core = require("@material-ui/core");

require("./ConfirmationModal.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ConfirmationModal = function ConfirmationModal(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_core.Dialog, {
    open: props.open,
    onClose: function onClose() {
      return props.negativeCallback();
    },
    fullWidth: true,
    maxWidth: "sm"
  }, _react["default"].createElement(_core.Paper, null, _react["default"].createElement(_core.Card, {
    raised: true
  }, _react["default"].createElement(_core.CardHeader, {
    style: {
      backgroundColor: _colors["default"].brand_1,
      color: "#FFFFFF"
    },
    title: props.title
  }), _react["default"].createElement(_core.CardContent, {
    style: {
      textAlign: "center",
      flexDirection: "column"
    }
  }, _react["default"].createElement(_.Typography, {
    gutterBottom: true
  }, props.message), _react["default"].createElement("div", {
    style: {
      textAlign: "center",
      flexDirection: "column",
      marginTop: "20px"
    }
  }, _react["default"].createElement(_.Button, {
    onClick: function onClick() {
      return props.affirmativeCallback();
    }
  }, props.affirmativeChoice), _react["default"].createElement(_.Typography, null, " "), _react["default"].createElement(_core.Button, {
    variant: "text",
    style: {
      color: _colors["default"].fiord
    },
    onClick: function onClick() {
      return props.negativeCallback();
    }
  }, props.negativeChoice))))));
};

ConfirmationModal.propTypes = {
  open: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string,
  affirmativeChoice: _propTypes["default"].string,
  negativeChoice: _propTypes["default"].string,
  affirmativeCallback: _propTypes["default"].func,
  negativeCallback: _propTypes["default"].func
};
ConfirmationModal.defaultProps = {
  open: false,
  title: "Title",
  message: "Are you sure?",
  affirmativeChoice: "Yes",
  negativeChoice: "No"
};
var _default = ConfirmationModal;
exports["default"] = _default;